import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout, ScrollToTop } from "@/components/Layout";
import Home from "@/pages/Home";
import Mahavidyas from "@/pages/Mahavidyas";
import Culture from "@/pages/Culture";
import Partnerships from "@/pages/Partnerships";
import Contact from "@/pages/Contact";
import Media from "@/pages/Media";
import Legal from "@/pages/Legal";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/mahavidyas" element={<Mahavidyas />} />
                    <Route path="/culture-community" element={<Culture />} />
                    <Route path="/partnerships" element={<Partnerships />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/media-features" element={<Media />} />
                    <Route path="/privacy-policy" element={<Legal page="privacy" />} />
                    <Route path="/cookie-policy" element={<Legal page="cookies" />} />
                    <Route path="/terms-of-use" element={<Legal page="terms" />} />
                    <Route path="/photography-notice" element={<Legal page="photography" />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
